export class MenuItem {
  name: string;
  icon: string;
  hrefLink: string;
  constructor(name?: string, icon?: string, hrefLink?: string) {
    this.name = name || '';
    this.icon = icon || '';
    this.hrefLink = hrefLink || '';
  }
}
